import { useDispatch } from "react-redux"

import { bindActionCreators } from "@reduxjs/toolkit"

import { healthActions } from "./healthSlice"

export function useHealthActions() {
  const dispatch = useDispatch()
  return bindActionCreators(healthActions, dispatch)
}
